var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowWhiteLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66699 8.49992C2.66699 8.13173 2.96547 7.83325 3.33366 7.83325H12.667C13.0352 7.83325 13.3337 8.13173 13.3337 8.49992C13.3337 8.86811 13.0352 9.16659 12.667 9.16659H3.33366C2.96547 9.16659 2.66699 8.86811 2.66699 8.49992Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52827 3.36201C7.78862 3.10166 8.21073 3.10166 8.47108 3.36201L13.1377 8.02868C13.3981 8.28903 13.3981 8.71114 13.1377 8.97149L8.47108 13.6382C8.21073 13.8985 7.78862 13.8985 7.52827 13.6382C7.26792 13.3778 7.26792 12.9557 7.52827 12.6953L11.7235 8.50008L7.52827 4.30482C7.26792 4.04447 7.26792 3.62236 7.52827 3.36201Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhiteLong);
export default __webpack_public_path__ + "static/media/arrow_white_long.76549807eca449ee764c9131de6e5614.svg";
export { ForwardRef as ReactComponent };